import { useMemo } from "react";
import { useChecklistData } from "@/react/components/CommunityOnboarding/NewChecklistComponents/CheckList/useCheckListData";
import { useChecklistStore } from "@/react/stores/useChecklistStore";

export const useChecklist = () => {
  const checklistData = useChecklistData();
  const { setChecklist, setFocusedStepKey, setExpandedSections } =
    useChecklistStore();

  useMemo(() => {
    setChecklist(checklistData.checklist || null);

    if (checklistData.checklist) {
      setFocusedStepKey(checklistData.initialFocusedStepKey || null);

      const initialExpandedSectionsRecord: Record<string, boolean> = {};
      checklistData.initialExpandedSections.forEach(sectionTitle => {
        initialExpandedSectionsRecord[sectionTitle] = true;
      });
      setExpandedSections(initialExpandedSectionsRecord);
    }
  }, [
    checklistData.checklist,
    checklistData.initialFocusedStepKey,
    checklistData.initialExpandedSections,
    setChecklist,
    setFocusedStepKey,
    setExpandedSections,
  ]);

  return {
    checklist: checklistData.checklist,
    isLoading: checklistData.isChecklistLoading,
    error: checklistData.errorFetchingChecklist,
    sectionsWithFocus: checklistData.sectionsWithFocus,
    totalSteps: checklistData.totalSteps,
    completedSteps: checklistData.completedSteps,
    progress: checklistData.progress,
    initialFocusedStepKey: checklistData.initialFocusedStepKey,
    initialExpandedSections: checklistData.initialExpandedSections,
    isComplete: checklistData.isComplete,
  };
};
